export const createVariables = <V extends string = string>() =>
  new Proxy({} as Record<V, string>, {
    get: (_, p: string) =>
      `--${p.replace(/[A-Z]/, (x) => `-${x.toLowerCase()}`)}`,
  });
